import { createFrontendModule } from '@backstage/frontend-plugin-api';
import {
  EntityCardBlueprint,
  EntityContentBlueprint,
} from '@backstage/plugin-catalog-react/alpha';
import { compatWrapper } from '@backstage/core-compat-api';
import type { Entity } from '@backstage/catalog-model';

// @roadiehq/backstage-plugin-github-pull-requests (3.7.0) ships only OLD-frontend-system exports —
// no `/alpha` entrypoint — so its entity card + content tab are bridged into the new frontend system
// with compatWrapper + the catalog-react Blueprints (per Backstage "Converting 3rd-party plugins from
// the old system"). Contrast the ArgoCD / GitHub-Actions / Grafana plugins, which ship native `/alpha`
// and are just discovered.
//
// Both surfaces gate on the github.com/project-slug annotation. We use an inline predicate rather than
// the plugin's isGithubPullRequestsAvailable (avoids eagerly importing the whole plugin bundle just
// for a filter) or a config EntityPredicate (its dotted path can't express an annotation key that
// itself contains a dot, which `github.com/project-slug` does).
const hasProjectSlug = (entity: Entity) =>
  Boolean(entity.metadata.annotations?.['github.com/project-slug']);

const pullRequestsCard = EntityCardBlueprint.make({
  name: 'github-pull-requests',
  params: {
    filter: hasProjectSlug,
    loader: async () => {
      const { EntityGithubPullRequestsOverviewCard } = await import(
        '@roadiehq/backstage-plugin-github-pull-requests'
      );
      return compatWrapper(<EntityGithubPullRequestsOverviewCard />);
    },
  },
});

const pullRequestsContent = EntityContentBlueprint.make({
  name: 'github-pull-requests',
  params: {
    path: '/pull-requests',
    title: 'Pull Requests',
    filter: hasProjectSlug,
    loader: async () => {
      const { EntityGithubPullRequestsContent } = await import(
        '@roadiehq/backstage-plugin-github-pull-requests'
      );
      return compatWrapper(<EntityGithubPullRequestsContent />);
    },
  },
});

export const githubPullRequestsModule = createFrontendModule({
  pluginId: 'github-pull-requests',
  extensions: [pullRequestsCard, pullRequestsContent],
});
